export const permissionsTenantsReadonly = [
  "tenants-full",
  "tenants-readonly",
  "everything-full",
  "everything-readonly",
];
